import React, { PureComponent } from 'react';
import { Table, Button, Pagination, Select } from 'element-react';
import styles from './result.css';
import style from './index.scss';

import { Link } from 'react-router-dom';


export default class Result extends PureComponent {
    state = {
        
    };

    onRowClick = () => {
        window.location = '/preferentialDetail';
    }

    render() {
        const {} = this.state;

        const columns = [
            {
                label: "事项名称",
                prop: "name",
                width: 300,
                // render: (row, column) => {
                //     return <Link to='/preferential/preferentialDetail'> <span style={{ color: '#18388c' }}>{row.name}</span></Link>
                // }
            },
            {
                label: "主管部门",
                prop: "department",
            },
            {
                label: "行政区划",
                prop: "administrator",
            },
            {
                label: "状态",
                prop: "state",
                render: (row, column) => {
                    return <span>{row.state}</span>
                }
            },
            {
                label: "操作",
                render: () => {
                    return <Link to='/educationTraining/resultDetail'><span style={{ color: '#18388c' }}>办件查询</span></Link>
                }
            }
        ];
        const dataSource = [
            { 'name': '退役军人互联网应用培训', 'department': '海南退役军人事务厅', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '退役军人互联网应用培训', 'department': '海南退役军人事务厅', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '退役军人互联网应用培训', 'department': '海南退役军人事务厅', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '退役军人互联网应用培训', 'department': '海南退役军人事务厅', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '退役军人互联网应用培训', 'department': '海南退役军人事务厅', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '退役军人互联网应用培训', 'department': '海南退役军人事务厅', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '退役军人互联网应用培训', 'department': '海南退役军人事务厅', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '退役军人互联网应用培训', 'department': '海南退役军人事务厅', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '退役军人互联网应用培训', 'department': '海南退役军人事务厅', 'administrator': '三亚市海棠区', 'state': '待审批' },
            { 'name': '退役军人互联网应用培训', 'department': '海南退役军人事务厅', 'administrator': '三亚市海棠区', 'state': '待审批' },
        ];
        return (
            <div className="main_search result">
                <div className="center" style={{ marginTop: '0' }}>
                    <div className="center_search">
                        <span style={{ color: '#18388c', fontSize: '24px', marginRight: '15px' }}>结果查询</span>
                        <span className="tips_txt">共有10个申办事项</span>
                    </div>
                    <div className="result_table" style={{ marginTop: '10px' }}>
                        <Table
                            style={{ width: '100%' }}
                            columns={columns}
                            data={dataSource}
                            border={false}
                        // onRowClick={this.onRowClick}
                        />
                    </div>
                    <div className="main_application">
                        <Pagination layout="prev, pager, next, jumper" total={1000} pageSize={100} currentPage={5} />
                    </div>

                </div>

            </div>
        )
    }
}